import React from "react";
import { GrantDto } from "../../../../dtos/GrantDto";
import { PhaseDto } from "../../../../dtos/PhaseDto";
import { useTaskSummaryController } from "./hooks/useTaskSummaryController";
import { TaskSummaryView } from "./components/TaskSummaryView";

export interface ITaskSummaryProps {
    phase: PhaseDto;
    grantNumber: string;
    grantId?: string;
    grantData?: GrantDto;
    hideSummary: boolean;
    onActionSelected?: () => void;
    onLoading?: () => void;
    onLoaded?: () => void;
    onClose: () => void;
    // Content pinned to the right of the summary title (e.g. the resubmission cycle picker).
    headerRight?: React.ReactNode;
}

export default function TaskSummary(props: ITaskSummaryProps) {
    const ctrl = useTaskSummaryController(props);
    return <TaskSummaryView {...ctrl} steps={ctrl.steps} headerRight={props.headerRight} />;
}
